import { render, staticRenderFns } from "./UsersPageCreate.vue?vue&type=template&id=70365cc8&"
import script from "./UsersPageCreate.vue?vue&type=script&lang=ts&"
export * from "./UsersPageCreate.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/src/client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('70365cc8')) {
      api.createRecord('70365cc8', component.options)
    } else {
      api.reload('70365cc8', component.options)
    }
    module.hot.accept("./UsersPageCreate.vue?vue&type=template&id=70365cc8&", function () {
      api.rerender('70365cc8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/feature/Provisioning/Users/UsersPageCreate.vue"
export default component.exports